<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('toolbar')">
      <div :class="b('tabs')" ref="tabs">
        <span :class="b('tab-pill')" ref="pill"></span>

        <button
          v-for="tab in displayedTabs"
          :key="tab.id"
          ref="tabButtons"
          :class="b('tab', { active: tab.acitve })"
          :disabled="tab.isDisabled"
          @click="handleTab(tab)"
        >
          {{ $t(tab.label) }}
        </button>
      </div>

      <SharedSearch
        :class="b('search')"
        :search="displayedSearch.value"
        placeholder="Поиск по операциям"
        @update:search="handleSearch"
      />

      <div :class="b('actions')">
        <button
          :class="
            b('button', { filter: true, active: isFilterOpen || hasFilter })
          "
          :aria-expanded="isFilterOpen"
          :aria-label="$t('Фильтры')"
          @click="handleFilter"
        >
          <span :class="b('button-icon')" v-html="displayedIcons.filter"></span>
        </button>

        <button
          v-if="hasFilter"
          :class="b('button', { clear: true })"
          :aria-label="$t('Очистить фильтры')"
          @click="handleClearFilter"
        >
          <span :class="b('button-icon')" v-html="displayedIcons.clear"></span>
        </button>
      </div>
    </div>
  </div>
</template>
